import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { CofOStatusDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-cof-ostatus-container',
  templateUrl: './cof-ostatus-container.component.html',
  styleUrls: ['./cof-ostatus-container.component.scss'],
})
export class CofOStatusContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  cofostatuss$: Observable<CofOStatusDto[]>;
  loading: boolean;
  isLoadingCofOStatus$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingCofOStatus$ = this.gatwayFacade.isLoadingGateway(
      'CofOStatus'
    );
    this.cofostatuss$ = this.gatwayFacade.loadGateway('CofOStatus');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteCofOStatus(deletedValue: any) {
    this.gatwayFacade.remove('CofOStatus', deletedValue);
  }

  // this method control both the create and update

  onSubmitCofOStatus(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.CofOStatuss;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllCofOStatus = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllCofOStatus.push(pullData[i]);
      }
    }

    // check if the addAllCofOStatus array is not empty, then dispatch the data to the store
    if (addAllCofOStatus.length > 0) {
      this.gatwayFacade.add('CofOStatus', addAllCofOStatus);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('CofOStatus', allUpdates, ['id']);
    }
  }
}
